// extracted by mini-css-extract-plugin
module.exports = {"title":"KfSubCategories_title__zUvkg","row":"KfSubCategories_row__145j8","button":"KfSubCategories_button__2MVcq","active":"KfSubCategories_active__3_vjS"};